import { useContext, useEffect, useState } from "react";
import ContextFlujos from "../Context/ContextFlujos";
import { Col, Container, Form, Modal, Row, Button } from "react-bootstrap";
import styles from '../BlueToGo/BlueToGo.module.css';
import Mark from "../assets/img/blue/checkmark.png";



const BlueToGoFinal = () => {
  const { setSkyPlus, setSkyCelular, setPais, blueToGo } = useContext(ContextFlujos) as any;



  useEffect(() => {
    // if (sessionStorage.getItem("flujos") === "Sky+") {
    //     setSkyPlus({estado:false});
    //   }

    //   if (sessionStorage.getItem("flujos") ===  "DTH/SkyCelular" || sessionStorage.getItem("flujos") ===  "DTH/DTH/SkyCelular/Sky+") {
    //     setSkyCelular({estado:true});
    //   }

    //   setPais(sessionStorage.getItem("pais"));

  }, []);

  return (
    <>
      <Container className={styles["containerFinal"]}>
        <Row>
          <div className={styles["centrarboton"] + " pt-5"}><img src={Mark} className={styles.imagen2} /></div>


          <b className={styles["boldtext"] + " pt-3"}>Activación exitosa</b>
          <p className={styles["parrafotext"] + " pt-3"}>Tu solicitud  de contratación de Blue To Go a través de Misky ha sido procesada correctamente.</p>
          <p className={styles["parrafotext"] + " pt-3"}>Disfruta de este servicio a través de nuestro sitio en www.skymas.com.mx y desde la app Sky+</p>

          <div className={styles["centrarboton"]}>



            <Button
              href="https://www.skymas.mx"
              target="_blank"
              variant="primary"
              className={styles["botonazul"]}
            >

              Ir a Sky+
            </Button>
          </div>
        </Row>

      </Container>
    </>
  );
};

export default BlueToGoFinal;
